import React, { createContext } from 'react';

const ConfigContext: React.Context<any> = createContext({});

const defaultConfig = {
	env: process.env.REACT_APP_ENV || '',
	apiBase: process.env.REACT_APP_API_BASE || '',
	logInUrl: process.env.REACT_APP_LOGIN || '',
	bookfairs: process.env.REACT_APP_BF || '',
	cbsUrl: process.env.REACT_APP_CBS || '',
	reCaptchaSiteKey: process.env.REACT_APP_RECAPTCHA_KEY || '',
	reCaptchaCheckboxKey: process.env.REACT_APP_CHECKBOX_KEY || '',
};

function ConfigProvider({ children }: any) {
	return <ConfigContext.Provider value={defaultConfig}>{children}</ConfigContext.Provider>;
}

export { ConfigContext, ConfigProvider };
